<template>
  <v-form class="multi-col-validation">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="firstName"
          label="First Name"
          outlined
          dense
          placeholder="First Name"
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="lastName"
          label="Last Name"
          outlined
          dense
          placeholder="Last Name"
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="email" label="Email" outlined dense placeholder="Email" hide-details></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="city" label="City" outlined dense placeholder="City" hide-details></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="country"
          label="Country"
          outlined
          dense
          placeholder="Country"
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="company"
          label="Company"
          outlined
          dense
          placeholder="Company"
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-checkbox v-model="checkbox" label="Remember me" class="mt-0" hide-details></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-btn color="primary"> Submit </v-btn>
        <v-btn type="reset" outlined class="mx-2"> Reset </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { ref } from 'vue'

export default {
  setup() {
    const firstName = ref('')
    const lastName = ref('')
    const city = ref('')
    const country = ref('')
    const company = ref('')
    const email = ref('')
    const checkbox = ref(false)

    return {
      firstName,
      lastName,
      city,
      country,
      company,
      email,
      checkbox,
    }
  },
}
</script>
